import { useEffect, useState } from "react";
import { CalendarGreyIcon, ClocckGreyIcon, DeleteRedIcon, FilterIcon, PlusThickWhiteIcon } from "../../../assets/icons";
import { LocalEventTableItemDTO } from "../../../models/localEvent/localEvent.response";
import AddLocalEventView from "./AddLocalEventView";
import { useNotification } from "../../toster-notification/NotificationContext";
import { useParams } from "react-router-dom";
import { localEventService } from "../../../services/localEventService";
import { ToLocalDateTimeString } from "../../../utils/dateFormater";
import EditLocalEventView from "./EditLocalEventView";
import { confirmDialog } from "../../../utils/confirmDialog";
import Loader from "../../shared/Loader";



export default function LocalEventPage() {

    const [isAddLocalEventModalOpen, setIsAddLocalEventModalOpen] = useState(false);
    const [isEditLocalEventModalOpen, setIsEditLocalEventModalOpen] = useState(false);
    const [selectedLocalEvent, setSelectedLocalEvent] = useState<string>("");

    const [localEvents, setLocalEvents] = useState<LocalEventTableItemDTO[]>([]);

    const [searchTerm, setSearchTerm] = useState<string>("");

    const [loading, setLoading] = useState<boolean>(false);
    const { notify } = useNotification();
    const { localId } = useParams<{ localId: string }>();


    useEffect(() => {
        fetchLocalEvents();
    }, [localId]);


    const fetchLocalEvents = async () => {
        if (!localId) {
            notify("error", "Local ID is missing");
            return;
        }

        setLoading(true);
        try {
            const response = await localEventService.GetForTableSettings(localId);
            if (response.success && response.data) {
                setLocalEvents(response.data);
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom učitavanja događaja");
        } finally {
            setLoading(false);
        }
    };

    const handleLocalEventAdded = async (id: string) => {
        if (!localId) {
            notify("error", "Local ID is missing");
            return;
        }

        const confirm = await confirmDialog({
            title: "Potvrda brisanja",
            description: "Da li ste sigurni da želite da obrišete ovaj događaj?",
            isDelete: true
        });

        if (!confirm)
            return;

        setLoading(true);
        try {
            const response = await localEventService.Delete(localId, id);

            if (response.success) {
                notify("success", "Događaj je uspešno obrisan");
                fetchLocalEvents();
            } else {
                notify("error", "Došlo je do greške prilikom brisanja događaja");
            }
        } catch (error) {
            notify("error", "Došlo je do greške prilikom brisanja događaja");
        } finally {
            setLoading(false);
        }
    };


    if (!localId) {
        return <div>Local ID is missing</div>;
    }

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            {isAddLocalEventModalOpen && (
                <AddLocalEventView
                    localId={localId}
                    onClose={() => {
                        setIsAddLocalEventModalOpen(false)
                        fetchLocalEvents();
                    }}
                />
            )}

            {isEditLocalEventModalOpen && selectedLocalEvent && (
                <EditLocalEventView
                    id={selectedLocalEvent}
                    localId={localId}
                    onClose={() => {
                        setIsEditLocalEventModalOpen(false);
                        setSelectedLocalEvent("");
                        fetchLocalEvents();
                    }}
                />
            )}

            <section className="localevent-section">
                <div className="w-layout-blockcontainer container w-container">
                    <div className="sttings-content-wrapper">
                        <div className="header-div">
                            <div>
                                <h2 className="heading-3">Dogadjaji u lokalu</h2>
                                <div className="text-block">
                                    Upravljajte predstojećim događajima u lokalu<br />
                                </div>
                            </div>
                            <div className="header-button-div">
                                <div className="button-primary" onClick={() => setIsAddLocalEventModalOpen(true)}>
                                    <img loading="lazy" src={PlusThickWhiteIcon} alt="" className="button-image" />
                                    <div className="button-text">Novi događaj</div>
                                </div>
                            </div>
                        </div>
                        <div className="div-block-130">
                            <div className="admin-settings-box-div statistic">
                                <div className="description-text">Ukupno dogadjaja</div>
                                <div className="text-block-61">{localEvents.length}</div>
                            </div>
                            <div className="admin-settings-box-div statistic">
                                <div className="description-text">Objavljeno</div>
                                <div className="text-block-61">{localEvents.filter((e) => e.isPublished).length}</div>
                            </div>
                            <div className="admin-settings-box-div statistic">
                                <div className="description-text">Istaknuto</div>
                                <div className="text-block-61">{localEvents.filter((e) => e.isFeatured).length}</div>
                            </div>
                        </div>
                        <div className="admin-settings-box-div eventlist">
                            <div className="list-header">
                                <div className="list-header-info">
                                    <div className="list-header-title">Svi događaji</div>
                                    <div className="list-header-description">
                                        Ukupno: {localEvents.length} ({localEvents.filter((e) => e.isPublished).length} aktivnih)<br />
                                    </div>
                                </div>
                                <div className="list-header-filer">
                                    <img loading="lazy" src={FilterIcon} alt="" className="subcategory-header-filter-image" />
                                    <div className="list-header-filer-form w-form">
                                        <form className="form">
                                            <input className="form-input w-input" placeholder="Pretrazi stavke" type="text"
                                                value={searchTerm}
                                                onChange={(e) => setSearchTerm(e.target.value)}
                                            />
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="local-event-settings-list-div">

                                {localEvents
                                    .filter((localEvent) =>
                                        localEvent.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                                        localEvent.description.toLowerCase().includes(searchTerm.toLowerCase())
                                    )
                                    .map((localEvent) => (
                                        <div className="local-event-settings-block">
                                            <div className="div-hr"></div>
                                            <div className="local-event-settings-div">

                                                {localEvent.imageUrl && (
                                                    <img src={localEvent.imageUrl + "@sm.webp"} loading="lazy" alt="" className="local-event-settings-image" />
                                                )}

                                                <div className="local-event-settings-info-div">
                                                    <div className="local-event-settings-info-header-div">
                                                        <div className="text-block-62">{localEvent.title}</div>
                                                        <div className="div-block-134">
                                                            {localEvent.isPublished && (
                                                                <div className="small-box-div grey-bg">
                                                                    <div>Objavljen</div>
                                                                </div>
                                                            )}
                                                            {localEvent.isFeatured && (
                                                                <div className="small-box-div light-purple-bg">
                                                                    <div>Istaknuto</div>
                                                                </div>
                                                            )}
                                                            <div className="small-box-div pointer ml-auto"
                                                                onClick={() => {
                                                                    setSelectedLocalEvent(localEvent.id)
                                                                    setIsEditLocalEventModalOpen(true)
                                                                }}
                                                            >
                                                                <div>Izmeni</div>
                                                            </div>
                                                            <img loading="lazy" src={DeleteRedIcon} alt="" className="category-list-div-row-actions-image"
                                                                onClick={() => handleLocalEventAdded(localEvent.id)}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="description-text">{localEvent.description || `Nema opisa`}</div>
                                                    <div className="div-block-132 description-text">
                                                        <div className="div-block-131">
                                                            <img src={CalendarGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                                                            <div>{ToLocalDateTimeString(localEvent.startsAtUtc)}</div>
                                                        </div>
                                                        <div className="div-block-131">
                                                            <img src={ClocckGreyIcon} loading="lazy" alt="" className="icon-size-16" />
                                                            <div>{ToLocalDateTimeString(localEvent.endsAtUtc)}</div>
                                                        </div>
                                                        {localEvent.priceText && (
                                                            <div className="div-block-131">
                                                                <div>{localEvent.priceText}</div>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="div-block-134 for-phone">
                                                {localEvent.isPublished && (
                                                    <div className="small-box-div grey-bg">
                                                        <div>Objavljen</div>
                                                    </div>
                                                )}
                                                {localEvent.isFeatured && (
                                                    <div className="small-box-div light-purple-bg">
                                                        <div>Istaknuto</div>
                                                    </div>
                                                )}
                                                <div className="small-box-div pointer ml-auto"
                                                    onClick={() => {
                                                        setSelectedLocalEvent(localEvent.id)
                                                        setIsEditLocalEventModalOpen(true)
                                                    }}
                                                >
                                                    <div>Izmeni</div>
                                                </div>
                                                <img loading="lazy" src={DeleteRedIcon} alt="" className="category-list-div-row-actions-image"
                                                    onClick={() => handleLocalEventAdded(localEvent.id)}
                                                />
                                            </div>
                                        </div>
                                    ))}

                            </div>
                        </div>
                    </div>
                </div>
            </section>


        </>

    );
}